import qs from 'qs';
import VueLodash from "vue-lodash";

const Visit = {
    namespaced: true,

    state: {
        visitData: [],
        visitCount:[],
        answerData: [],
    },

    getters: {
        visitData (state) {
            return state.visitData;
        },  
        visitCount (state) {
            return state.visitCount;
        },
        answerData (state) {
            return state.answerData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['visitData'] = items;
        },
        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArrCount (state, { items }) {
            state['visitCount'] = items;
        },
        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArrAnswer (state, { items }) {
            state['answerData'] = items;
        },
        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['visitData'][index] = item;
        },
                /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItemCount (state, { item, index }) {
            state['visitCount'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['visitData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['visitData'] = state['visitData'].filter(iItem => iItem !== item);
        },
        /**
         * Удалить элемент из объекта ответов
         * @param state
         * @param item
         */
        removeAnswer (state, { item }) {
            state['answerData'] = state['answerData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получаем данные по визитам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getVisitData ({ commit, dispatch, getters, rootGetters }, filterSettings, pagination) {  
            //  console.log('NAU: getVisitData -> filterSettings', filterSettings) 
            // console.log('NAU: getVisitData -> filterSettings.find.text,', filterSettings.find(a => a.searchKey === 'shopName').text)
                        
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'visit/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'start': pagination['pagination'].start,
                        'top': pagination['pagination'].top,
                        'visitDate': filterSettings.find(a => a.searchKey === 'visitDate').text,
                        'fullName': filterSettings.find(a => a.searchKey === 'fullName').text,
                        'employeeName':  filterSettings.find(a => a.searchKey === 'employeeName').text,
                        'shopName':  filterSettings.find(a => a.searchKey === 'shopName').text,
                        'shopId':  filterSettings.find(a => a.searchKey === 'shopId').text,
                        'shopEmployeeId':  filterSettings.find(a => a.searchKey === 'shopEmployeeId').text,
                    }),
                }).then(response => {
                    commit('setArr', {
                        items: response.data
                    });
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по визитам получены!');
                    resolve()
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по визитам!');
                    console.log('ERROR IN visit.js | getVisitData : ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Получаем данные по визитам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getVisitCountData ({ commit, dispatch, getters, rootGetters }, filterSettings) {
            // console.log('NAU: getVisitCountData -> filterSettings.find.text,', filterSettings.find(a => a.searchKey === 'shopName').text)
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'visit/count',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'visitDate': filterSettings.find(a => a.searchKey === 'visitDate').text,
                        'fullName': filterSettings.find(a => a.searchKey === 'fullName').text,
                        'employeeName':  filterSettings.find(a => a.searchKey === 'employeeName').text,
                        'shopName':  filterSettings.find(a => a.searchKey === 'shopName').text,
                        'shopId':  filterSettings.find(a => a.searchKey === 'shopId').text,
                        'shopEmployeeId':  filterSettings.find(a => a.searchKey === 'shopEmployeeId').text,
                    }),
                }).then(response => { 
                    commit('setArrCount', {
                        items: response.data
                    });
                    // console.log('NAU: getVisitCountData ->   response.data',   response.data)
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по количеству визитов получены!');
                    resolve()
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по колличеству визитов!');
                    console.log('ERROR IN visit.js | getVisitCountData : ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Сохраняем данные по визитам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @param data
         * @returns {Promise<any>}
         */
        saveVisitData ({ commit, dispatch, getters, rootGetters }, data ) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                const updLocation = JSON.stringify(data.updateLocation);
                console.log(updLocation);
                axios({
                    url: rootGetters.rootUrl + 'visit/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'updateLocation': updLocation,
                    }),
                }).then(response => {
                    commit('setItem', {
                        item: data.data,
                        index: data.index
                    });
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по визиту успешно сохранены!');
                    resolve()
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных визита!');
                    console.log('ERROR IN visit.js | saveVisitData : ' + err);
                    reject(err);
                });
            })
        },
        /**
         * Получаем данные вопросам и анкетам
         * @param {*} param0 
         * @param {*} data 
         */
        getAnswerVisitData ({ commit, dispatch, getters, rootGetters },data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true}); 
                // data.data.visitUid.toString();
                axios({
                    url: rootGetters.rootUrl + 'answer-visit/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'visitUid':  data.data.visitUid.toString(),
                    }),
                }).then(response => {
                    commit('setArrAnswer', {
                        items: response.data
                    });
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по вопросам получены!');
                    resolve()
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по вопросам!');
                    console.log('ERROR IN visit.js | getVisitData : ' + err);
                    reject(err);
                });
            })
        },
        /**
         * Сохраняем данные по ответам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @param data
         * @returns {Promise<any>}
         */
        saveAnswerVisitData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                const uid = data.visitUid.toString();
                axios({
                    url: rootGetters.rootUrl + 'answer-visit/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'visitUid':  uid,
                    }),
                }).then(response => {
                    commit('setItem', {
                        item: data.data,
                        index: data.index
                    });
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по визиту успешно сохранены!');
                    resolve()
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных визита!');
                    console.log('ERROR IN visit.js | saveVisitData : ' + err);
                    reject(err);
                });
            })
        },
        /**
         * Удаление ответа из анкеты
         * @param {*} param0 
         * @param {*} data 
         */
        removeAnswerData({ commit, dispatch, getters, rootGetters }, data){
                commit('removeAnswer', {
                    item: data.item,
                }); 
             
        },
         /** 
         * Загрузка фотографий на сервер
         * @param {*} param0 
         * @param {*} data - данные по фото
         */
        uploadPhotoData ({ commit, dispatch, getters, rootGetters }, data) { 
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true}); 
                const str = JSON.stringify(data.data, true);
                console.log('NAU: uploadPhotoData -> data.data', data.data)
                
                axios({
                    url:  rootGetters.netUrl + '/photos-2',
                    method: 'POST',
                    headers: {  
                        'content-type': 'application/json'
                    }, 
                    data: str 
                    
                }).then(response => (
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Фото загружено.'),
                        resolve(response)
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN logServer.js | getlogServerData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка выгрузки фото!'),
                        reject(err);
                });
            })
        },
    },
};

export default Visit;





// WEBPACK FOOTER //
// ./src/store/modules/visit.js